import { render, staticRenderFns } from "./TrailerEdit.vue?vue&type=template&id=61cf2b28"
import script from "./TrailerEdit.vue?vue&type=script&lang=js"
export * from "./TrailerEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports